import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { NumberInputField } from '../../../../Form';

interface IProps {
  value: number | null;
  onChange: (value: number | null) => void;
  placeholder?: string;
  hasError?: boolean;
  errorMessage?: string;
  shouldAutoFocus?: boolean;
}

const Container = styled(NumberInputField)`
  width: 60px;
  flex: 0 0 60px;
  > input {
    width: 100%;
  }
`;

export default ({
  value,
  onChange,
  placeholder,
  hasError,
  shouldAutoFocus,
  errorMessage,
}: IProps) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (shouldAutoFocus) {
      ref?.current?.focus?.();
    }
  });

  return (
    <Container
      ref={ref}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      hasError={hasError}
      errorMessage={errorMessage}
      min={0}
      max={99}
    />
  );
};
